"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableActivity = disableActivity;
exports.activity = activity;
exports.isActive = isActive;

var APP_ACTIVITY = +new Date();
var DISABLE_ACTIVITY = false;

function disableActivity() {
  DISABLE_ACTIVITY = true;
}

window.disableActivity = disableActivity;

function activity() {
  APP_ACTIVITY = +new Date();
}

function isActive(miliseconds) {
  if (DISABLE_ACTIVITY) return true;
  var lastActivity = APP_ACTIVITY;
  return +new Date() - lastActivity < miliseconds;
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-utils/dist/activity.js
// module id = 143
// module chunks = 0